export default __webpack_public_path__ + "static/media/girl-mobile.edd34f34.png";